import Scrambler from '../vendor/scrambler/scrambler.js';


const scrambler = new Scrambler({
    target: '[data-scrambler]',
    random: [500, 1500],
    speed: 20
  });